<!--  
	menu: manually adjusting the training level
-->



<script>

	// imports
	// ------------------------------------------------------------------------
	import appState from '../Data/state.svelte.js';
	import string from '../Data/translations.js';
	import training from '../Data/training.js';
	import Menu from '../UI/Menu.svelte';


	// local properties
	// ------------------------------------------------------------------------
	let userSkill = $state(appState.level);
	let userSet = $state(appState.set);
	// the sets available in the training data for the chosen skill
	let sets = $derived(Object.keys(training[userSkill]).map(Number));


	// purpose:		changes the skill and keeps the chosen set in the sets of
	//				that skill, moving it to the closest one when it has no such set
	// arguments:	the chosen skill (int)
	// ------------------------------------------------------------------------
	function changeSkill(skill){
		let skillSets = Object.keys(training[skill]).map(Number);

		userSkill = skill;
		userSet = Math.min(Math.max(userSet, Math.min(...skillSets)), Math.max(...skillSets));
	};


	// purpose:		sets the user info according to user input
	// returns:		dispatches 'manualSkill' and 'leveled' events and redirects to Home page
	// ------------------------------------------------------------------------
	function setSkill(){
		window.dispatchEvent(new CustomEvent('manualSkill', { detail: {level: userSkill, set: userSet} }));
		window.dispatchEvent(new CustomEvent('leveled', { detail: {level: userSkill} }));

		// the congratulations for passing 100 pushups are shown again when
		// the user moves to another skill or to one of the first 6 levels
		let skillChanged = userSkill !== appState.level;
		let levelChanged = userSet !== appState.set && userSet < 7;

		if(skillChanged || levelChanged){
			appState.setCongrats(false);
		}

		appState.setLevel(userSkill);
		appState.setSet(userSet);
		appState.setPage('Home');
	};

</script>




<Menu
	contentClass="menu-form"
	buttonBackLabel={string.cancel}
	buttonNextLabel={string.accept}
	buttonNextAction={setSkill}
>
	<div class="form-row">
		<h2 class="form-label">{string.setYourSkillTo}</h2>
		<select bind:value={() => userSkill, changeSkill}>
			<option value={1}>{string.beginner}</option>
			<option value={2}>{string.intermediate}</option>
			<option value={3}>{string.advanced}</option>
		</select>
	</div>
	<div class="form-row">
		<h2 class="form-label">{string.setYourLevelTo}</h2>
		<select bind:value={userSet}>
			{#each sets as set (set)}
				<option value={set}>{set}</option>
			{/each}
		</select>
	</div>
</Menu>